module.exports = __webpack_public_path__ + "img/icon_phone.f1873474.svg";